import React from "react";
import style from "../../Styles/Components/Input.module.css";

const InputTitle = ({ children = null, title, valid = {
  isRequired: false,
  maxlength: 0
} }) => (
  <div className={style.container}>
    <div className={style.title}>
        {title}
    </div>
      {children}
  </div>
);

export default InputTitle;
